import { selectorFamily } from 'recoil';
import UseHttpRequest from '../../components/api/HttpRequest';

const LifetimeBalanceSelector = selectorFamily({
  key: 'lifetimeBalanceSelector',
  get: (networkUserId) => async () => {
    if (!networkUserId) {
      return 0;
    }

    try {
      const httpRequest = UseHttpRequest();
      const result = await httpRequest.send(`/leaderboards/record/${networkUserId}/DMD`);

      console.log('lifetime balance result', result);

      return Number(result?.score) || 0;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Error fetching a users lifetime diamond balance...', err);
      return 0;
    }
  },
});

export default LifetimeBalanceSelector;
